export default "__VITE_ASSET__ZPgVc_Nt__"